import { create } from "zustand";
import type { ISocial } from "../types/models/social.models.types";

interface ISocialStore {
  data: ISocial[];
  setData: (data: ISocial[]) => void;
  removeById: (id: string) => void;
}

const useUserStore = create<ISocialStore>((set) => ({
  data: [],
  setData: (data: ISocial[]) => set(() => ({ data })),
  removeById: (id: string) =>
    set((state) => ({
      data: state.data.filter((user) => user.id !== id),
    })),
}));

export default useUserStore;
